module.exports = __webpack_public_path__ + "img/slider-bg.49715b9a.png";